import { Link, Navigate, useRouteLoaderData } from "react-router-dom";
import {
  isFreeOrganizationAccount,
  Organization,
} from "../../services/organization/organizationModel";
import { useTranslation } from "react-i18next";
import { User, getGuideLink } from "../../services/user/userModel";
import { useMemo } from "react";
import ImgCandidates from "../../assets/home/home-candidats.webp";
import ImgVideos from "../../assets/home/home-videos.webp";
import ImgGuide from "../../assets/home/home-guide.webp";

const OrganizationDashboardPage = () => {
  const { t } = useTranslation(["organization", "common"]);
  const { organization } = useRouteLoaderData("organization") as {
    organization: Organization;
  };
  const { loggedUser } = useRouteLoaderData("logged-user") as {
    loggedUser?: User;
  };

  const invitation = useMemo(() => {
    return loggedUser?.invitations?.[0] ?? null;
  }, [loggedUser]);
  const isValidInvitation = useMemo(() => {
    return (invitation?.organization?.subscriptions?.length ?? 0) > 0;
  }, [invitation]);
  const guideLink = useMemo(
    () => getGuideLink(loggedUser?.usage),
    [loggedUser?.usage],
  );
  const isFreeAccount = useMemo(
    () => isFreeOrganizationAccount(organization, loggedUser),
    [organization, loggedUser],
  );

  // Free pro accounts have no dashboard: everything happens on "my candidates"
  if (isFreeAccount) return <Navigate to="/organization/candidates" replace />;

  return (
    <div className="layout_content --bg--organization-dashboard">
      <div className="ui-page pro-screen">
        <div className="ui-ph">
          <div className="ui-ph_t">
            <h1>{t("organization:dashboard.WELCOME_RECRUITER_DASHBOARD")}</h1>
            <p>
              {t("organization:dashboard.WELCOME_SUBTITLE", {
                firstname: loggedUser?.firstname,
                organization: organization.legalName,
              })}
            </p>
          </div>
        </div>

        {!isValidInvitation &&
          (organization.subscriptions ?? []).length === 0 && (
            <div className="ui-banner --warn">
              <span className="pro-ico --alert" aria-hidden="true" />
              <div className="ui-banner_grow">
                {t("organization:dashboard.NO_SUBSCRIPTION")}{" "}
                <Link className="link --underlined" to="pro/subscription">
                  {t("organization:dashboard.SUBSCRIBE")}
                </Link>
              </div>
            </div>
          )}
        {/* {!organization.stripeCustomer && (
          <div className="lblock info --warning">
            {t("organization:dashboard.NO_PAYMENT_METHOD")}{" "}
            <Link className="link --underlined" to="pro/subscription">
              {t("organization:dashboard.REGISTER_PAYMENT_METHOD")}
            </Link>
          </div>
        )} */}
        {invitation &&
          (isValidInvitation ? (
            <div className="ui-banner --ok">
              <span className="pro-ico --check" aria-hidden="true" />
              <div className="ui-banner_grow">
                {t(
                  "organization:subscription.INVITATION_VALID_SUB_DESCRIPTION",
                  {
                    replace: {
                      pro: invitation.organization?.legalName,
                    },
                  },
                )}
              </div>
            </div>
          ) : (
            <div className="ui-banner --warn">
              <span className="pro-ico --alert" aria-hidden="true" />
              <div className="ui-banner_grow">
                {t(
                  "organization:subscription.INVITATION_EXPIRED_SUB_DESCRIPTION",
                  {
                    replace: {
                      pro: invitation.organization?.legalName,
                    },
                  },
                )}
              </div>
            </div>
          ))}
        {organization && !loggedUser?.adminOrga && (
          <div className="ui-banner --ok">
            <span className="pro-ico --check" aria-hidden="true" />
            <div className="ui-banner_grow">
              {t("organization:MEMBER_OF_ORGANIZATION", {
                replace: {
                  pro: organization.legalName,
                },
              })}
            </div>
          </div>
        )}

        {/* Accueil sobre, inspiré de stats (Nicolas, 31/10) : une carte par rubrique, avec un visuel tiré du
            site (captures aux noms floutés, photo libre de droits) et une phrase traduite. Voile de couleur par
            rubrique (Nicolas, 01/11 : trop de visages, c'était confus). */}
        <div className="pro-home">
          <Link to="candidates" className="pro-card">
            <span className="pro-card_media --candidates">
              <img src={ImgCandidates} alt="" />
            </span>
            <div className="pro-card_body">
              <h2>{t("organization:dashboard.MY_CANDIDATES")}</h2>
              <p>{t("organization:dashboard.MY_CANDIDATES_DESC")}</p>
              <span className="pro-card_go">
                {t("organization:dashboard.OPEN")}
              </span>
            </div>
          </Link>
          {!isFreeAccount && (
            <Link to="capsules" className="pro-card">
              <span className="pro-card_media --videos">
                <img src={ImgVideos} alt="" />
              </span>
              <div className="pro-card_body">
                <h2>{t("organization:dashboard.MY_JOB_POSTINGS")}</h2>
                <p>{t("organization:dashboard.MY_JOB_POSTINGS_DESC")}</p>
                <span className="pro-card_go">
                  {t("organization:dashboard.OPEN")}
                </span>
              </div>
            </Link>
          )}
          {!isFreeAccount && guideLink && (
            <a
              href={guideLink}
              className="pro-card"
              target="_blank"
              rel="noreferrer"
            >
              <span className="pro-card_media --guide">
                <img src={ImgGuide} alt="" />
              </span>
              <div className="pro-card_body">
                <h2>{t("common:header.RECRUITER_GUIDE")}</h2>
                <p>{t("organization:dashboard.GUIDE_DESC")}</p>
                <span className="pro-card_go">
                  {t("organization:dashboard.OPEN")}
                </span>
              </div>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrganizationDashboardPage;
